import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./sectionView.css";

interface Props {
  sectionName: string;
  items: Array<any>;
  collectionKey: string;
  collectionName: string;
  currentItemId: string;
  requestExpanded: boolean;
}

export function SectionView({
  sectionName,
  items,
  collectionKey,
  collectionName,
  currentItemId,
  requestExpanded,
}: Props) {
  const noSection = !sectionName || sectionName === "undefined";
  const [expanded, setExpanded] = useState(noSection);

  const selectedClass = (it: any) =>
    it[collectionKey] === currentItemId ? "active" : "";
  const icon = () => (expanded ? "-" : "+");

  useEffect(() => setExpanded(noSection || requestExpanded), [noSection, requestExpanded]);

  return (
    <>
      {!noSection && (
        <li
          key={sectionName}
          className="selection-view__list-item list-group-item noselect"
          onClick={() => setExpanded(!expanded)}
        >
          {icon()} {sectionName}
        </li>
      )}
      {expanded &&
        items.map((it) => (
          <Link
            title={it[collectionKey]}
            to={`/${collectionName}/${it[collectionKey]}`}
            key={it[collectionKey]}
            className={`list-group-item ${selectedClass(it)}`}
          >
            {it[collectionKey]}
          </Link>
        ))}
    </>
  );
}
